export default "__VITE_ASSET__80b250e1__"